import { useEffect } from "react";
import { useState } from "react";

import { CustomDatePicker } from "../../../CustomDatePicker/CustomDatePicker";

export const FilterDate = (props) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    //Set default date range on first render
    useEffect(() => {
        var newDate = new Date();
        newDate.setFullYear(newDate.getFullYear() + 1)
        setEndDate(newDate);
    }, []);

    //On date change, update state
    useEffect(() => {
        props.filter.dateStartValue = startDate;
        props.filter.dateEndValue = endDate;
        let newState = { ...props.ficheData };
        props.setFicheData(prev => {
            return {
                ...prev,
                filter: newState.filter
            }
        });
    }, [startDate, endDate]);

    return <div className={`date-filter col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 6}`}>
        <div className="date-filter-inner">
            <div className="date-filter-part">
                <label>
                    <strong>
                        {props.filter ? props.filter.titleFrom : props.dictionary.from}
                    </strong>
                </label>
                <CustomDatePicker date={startDate} setDate={setStartDate} />
            </div>
            <div className="date-filter-part">
                <label>
                    <strong>
                        {props.filter ? props.filter.titleUntil : props.dictionary.until}
                    </strong>
                </label>
                <CustomDatePicker date={endDate} setDate={setEndDate} />
            </div>
        </div>
    </div>;
}